import { useCallback, useState } from 'react';

import { PlayerInfoWithProjectionsFragment } from '@/api/events/query.generated';
import TilePlaceholderImage from '@/assets/images/tilePlaceholderImage';
import { Box } from '@/components/lib/components/Box';
import { ds } from '@/components/lib/design.system';
import { TilePlayerImageCanvas } from '@/components/player-profile/tiles/TilePlayerImageCanvas';
import { containerHeight } from '@/components/player-profile/tiles/utils';
import { common } from '@/styles/styles';
import { isPlayerImgPlaceholder } from '@/utils/player';

const CONTAINER_WIDTH = 72;

export const EventHudPlayerIcon = ({ playerData }: { playerData?: Partial<PlayerInfoWithProjectionsFragment> }) => {
    const [hasErrorLoadingImage, setHasErrorLoadingImage] = useState(false);
    const isPlaceholderImage = isPlayerImgPlaceholder(playerData?.icon) || hasErrorLoadingImage;
    const onImageError = useCallback(() => {
        setHasErrorLoadingImage(true);
    }, []);

    return (
        <Box width={CONTAINER_WIDTH} height={containerHeight} alignItems="center">
            <TilePlayerImageCanvas
                teamColor={'transparent'}
                bgColor={ds.colorToken.background.neutral.subtler}
                source={playerData?.icon ?? ''}
                hideImage={isPlaceholderImage}
                containerWidth={CONTAINER_WIDTH}
                onError={onImageError}
            />
            {isPlaceholderImage ? (
                <Box position="absolute" style={common.zIndex1} top={15} width={CONTAINER_WIDTH} alignItems="center">
                    <Box top={-20}>
                        <TilePlaceholderImage id={playerData?.id ?? ''} />
                    </Box>
                </Box>
            ) : null}
        </Box>
    );
};
